import React from "react";
import ReactDOM from "react-dom";
import App from "./app";

const rootElement = document.getElementById("benefits-root");
const video = rootElement.dataset.video;
if (rootElement) {
    ReactDOM.render(<App video={video} />, rootElement);
}
